export const headTitle = (FormOptions, includesField) => {
  const titleArray = FormOptions.filter((item) => {
    return includesField.includes(item.labelName);
  }).map((item) => {
    return { title: item.labelName, value: item.valueLabel };
  });
  return titleArray;
};
